// import Layout from './components/layout';
import AcceptOfferForm from './components/AcceptOfferForm.vue';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import Login from './components/Login';
import Home from './components/FCS/Home'
import AccountingPlaidLink from './components/AccountingPlaidLink'
import AccountingReply from './components/AccountingReply'
// import ParticipationPage from './components/ParticipationPage'
import ResetPassword from "./components/Auth/ResetPassword.vue";
import SuperSyndicate from './components/SuperSyndicate/SuperSyndicate';

import TopNavbar from './components/TopNavbar'
import v2Routes from './v2/router/v2Routes'

const routes = [
    { path: '/login', name: "Login", component: Login },
    {
        path: "/",
        component: TopNavbar,
        children: [
            { path: 'dashboard', name: "Dashboard", component: Dashboard },
            { path: 'fcs/:unique_id', name: "Fcs", component: Home },
            { path: 'accounting_reply/:unique_id', name: "accounting_reply", component: AccountingReply },
            // { path: 'prefunding/:unique_id', name: "accept_participation", component: ParticipationPage },
            { path: 'iso-potal/:unique_id/:user_id/:lender_id', component: AcceptOfferForm },
            { path: 'profile', name: "Profile", component: Profile },
            { path: 'plaid', name: "Plaid", component: AccountingPlaidLink },
            { path: 'super-syndicate', name: "SuperSyndicate", component: SuperSyndicate },
          
        ]
    },
    ...v2Routes,
    {
        path: "/reset_password_view",
        component: ResetPassword,
        name: "auth-resetPassword"
    },
];

export default routes;